<div class="dead-link" dataSelector="qpl-dead-link-card">
  @if (portalOff) {
    <div class="dead-link__icon" aria-hidden="true">&#10005;</div>

    <h2 class="dead-link__heading" dataSelector="qpl-dead-link-heading">{{ firmName }} isn't accepting online payments right now</h2>

    <p class="dead-link__body" dataSelector="qpl-dead-link-body">Online payments have been switched off for this firm, so payments can't be taken here at the moment. Nothing has been charged.</p>
  } @else {
    <div class="dead-link__icon" aria-hidden="true">!</div>

    <h2 class="dead-link__heading" dataSelector="qpl-dead-link-heading">This payment link isn't active</h2>

    <p class="dead-link__body" dataSelector="qpl-dead-link-body">The link you opened can't take a payment. It may have already been used, or been replaced with a newer one. Nothing has been charged. If you pasted it from an email, it's worth checking the whole address came through.</p>

    @if (configService.openPaymentPortalEnabled) {
      <button
        type="button"
        class="dead-link__action"
        dataSelector="qpl-dead-link-open-portal"
        (click)="makePaymentWithoutLink()"
      >
        <span class="dead-link__action-title">Make a payment without a link</span>
        <span class="dead-link__action-subtitle">Enter the amount you were asked to pay and send it straight to {{ firmName }}.</span>
      </button>
    }
  }

  <hr class="dead-link__divider" aria-hidden="true">

  <div class="dead-link__contact">
    <p class="dead-link__contact-question" dataSelector="qpl-dead-link-contact-lead">
      @if (portalOff) {
        To arrange another way to pay, contact them directly.
      } @else {
        Need a link for a specific amount?
      }
    </p>
    <p class="dead-link__contact-firm" dataSelector="qpl-dead-link-firm-name">{{ firmName }}</p>

    @if (firmContactService.show) {
      @if (firmContactService.email; as email) {
        <a dataSelector="qpl-dead-link-firm-email" class="dead-link__contact-email" [href]="'mailto:' + email">{{ email }}</a>
      }

      @if (firmContactService.address; as address) {
        <p dataSelector="qpl-dead-link-firm-address" class="dead-link__contact-address">{{ address }}</p>
      }
    }
  </div>
</div>
